<form #reportForm="ngForm">
	<section class="report-form">
		<section class="row">
			<section class="col-12">
				<section>
					<label for="clientName" class="text-12" dcrHTMLKey="LABEL_COMPANY_NAME">Client Name</label>
				</section>
				<input
					[disabled]="disableReportGeneration"
					type="text"
					class="form-control col-22"
					id="clientName"
					required
					[(ngModel)]="model.clientName"
					#clientNameModel="ngModel"
					name="clientName"
				/>
				<div [hidden]="clientNameModel.valid || !clientNameModel.touched" class="alert-danger" dcrHTMLKey="LABEL_CLIENT_NAME_MISSING">Client Name is required</div>
			</section>
			<section class="col-12">
				<section>
					<label for="suite" class="text-12" dcrHTMLKey="LABEL_SUITE">Subtitle (e.g. Fixed Income portfolio analysis) <span class="text-12"></span> </label>
				</section>
				<input [disabled]="disableReportGeneration" type="text" class="col-22 form-control" id="suite" [(ngModel)]="model.suite" name="suite" #suiteModel="ngModel" />
			</section>
		</section>
		<section class="row" *ngIf="audienceValuesArray.length">
			<section class="col-12">
				<p class="text-12" dcrHTMLKey="AUDIENCE_DISCLAIMER_LABEL">Audience Disclaimer</p>
				<div class="text-14 ac-dropdown">
					<select [(ngModel)]="model.audience" name="audience" #audience="ngModel">
						<option *ngFor="let audience of audienceValuesArray" [value]="audience">{{ audience }}</option>
					</select>
				</div>
			</section>
		</section>
	</section>
</form>
